var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-mask" },
    [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c(
          "div",
          { staticClass: "scroll-box" },
          [
            _c(
              "v-container",
              { staticClass: "modal-container" },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      [
                        _c("h1", [_vm._v("Importação")]),
                        _vm.loading
                          ? _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "justify-center align-center"
                                  },
                                  [
                                    _c("v-progress-circular", {
                                      attrs: {
                                        size: 35,
                                        color: "primary",
                                        indeterminate: ""
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "v-row",
                          { staticClass: "command-col" },
                          [
                            _c("v-col", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn-update",
                                  attrs: {
                                    type: "button",
                                    disabled: _vm.loading,
                                    title:
                                      "Adicionar os investimentos desta importação para o Kristal"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.importItem($event)
                                    }
                                  }
                                },
                                [_vm._v(" Adicionar ao Kristal ")]
                              )
                            ]),
                            _c("v-col", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn-remote",
                                  attrs: {
                                    type: "button",
                                    disabled: _vm.loading,
                                    title:
                                      "Atualizar os dados importados com informações mais recentes"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.updateItem($event)
                                    }
                                  }
                                },
                                [_vm._v(" Solicitar atualização ")]
                              )
                            ]),
                            _c("v-col", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn-reload",
                                  attrs: {
                                    type: "button",
                                    disabled: _vm.loading,
                                    title:
                                      "Recarregar os dados armazenados na Kristal"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.$emit("reload")
                                    }
                                  }
                                },
                                [_vm._v(" Recarregar ")]
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c("v-col", [
                              _vm._v("Código: " + _vm._s(_vm.source.code))
                            ]),
                            _c("v-col", [
                              _c("span", { staticClass: "id-label" }),
                              _vm._v(" " + _vm._s(_vm.source.id))
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c("v-col", [
                              _c("span", { staticClass: "user-label" }),
                              _vm._v(" " + _vm._s(_vm.source.userId))
                            ]),
                            _c("v-col", [
                              _vm._v("Status: " + _vm._s(_vm.source.status))
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c("v-col", [
                              _vm._v(
                                "Execução: " +
                                  _vm._s(_vm.source.executionStatus)
                              )
                            ]),
                            _c("v-col", [
                              _vm._v(
                                "Mensagem da execução: " +
                                  _vm._s(_vm.source.message)
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c("v-col", [
                              _vm._v(
                                "Importação: " +
                                  _vm._s(_vm.formatDate(_vm.source.createdAt))
                              )
                            ]),
                            _c("v-col", [
                              _vm._v(
                                "Atualizado: " +
                                  _vm._s(_vm.formatDate(_vm.source.updatedAt))
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { staticClass: "bottom-row" },
                          [
                            _c("v-col", [
                              _vm._v(
                                "Registro: " +
                                  _vm._s(
                                    _vm.formatDate(_vm.source.lastUpdatedAt)
                                  )
                              )
                            ]),
                            _vm.source.connector
                              ? _c("v-col", [
                                  _vm._v(
                                    " Via: " +
                                      _vm._s(_vm.source.connector.id) +
                                      " - " +
                                      _vm._s(_vm.source.connector.name) +
                                      " (" +
                                      _vm._s(_vm.source.connector.type) +
                                      ") "
                                  ),
                                  _c("img", {
                                    staticClass: "thumb",
                                    attrs: {
                                      src: _vm.source.connector.imageUrl,
                                      alt: "Conector",
                                      width: "20",
                                      height: "20"
                                    }
                                  })
                                ])
                              : _c("v-col", [_vm._v(" De: Não identificado ")])
                          ],
                          1
                        ),
                        _vm.source.investments && _vm.source.investments.length
                          ? _c(
                              "v-row",
                              { staticClass: "data-table" },
                              [
                                _c(
                                  "v-col",
                                  [
                                    _c("h1", [_vm._v("Investimentos")]),
                                    _c("v-row", [
                                      _c("ul", [
                                        _c("li", [
                                          _vm._v(
                                            "Clique nos códigos dos investimentos para editá-los;"
                                          )
                                        ]),
                                        _c(
                                          "li",
                                          { staticClass: "desktop-item" },
                                          [
                                            _vm._v(
                                              "Passe o mouse sobre o status de importação para ver mensagem e data (se existir)."
                                            )
                                          ]
                                        )
                                      ])
                                    ]),
                                    _c(
                                      "v-row",
                                      { staticClass: "data-header" },
                                      [
                                        _c("v-col", [_vm._v("Nome")]),
                                        _c("v-col", [_vm._v("Código")]),
                                        _c("v-col", [_vm._v("Importação")]),
                                        _c("v-col", [_vm._v("Data")]),
                                        _c("v-col", [_vm._v("Vencimento")]),
                                        _c("v-col", [_vm._v("Marcado?")])
                                      ],
                                      1
                                    ),
                                    _vm._l(_vm.source.investments, function(
                                      investment
                                    ) {
                                      return _c(
                                        "v-row",
                                        {
                                          key: investment.investmentId,
                                          staticClass: "data-body",
                                          on: {
                                            click: function($event) {
                                              return _vm.viewInvestment(
                                                investment
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("v-col", [
                                            _c(
                                              "span",
                                              { staticClass: "short-label" },
                                              [_vm._v("Nome:")]
                                            ),
                                            _vm._v(
                                              " " +
                                                _vm._s(investment.name) +
                                                " "
                                            )
                                          ]),
                                          _c(
                                            "v-col",
                                            { staticClass: "code-editable" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  attrs: {
                                                    title:
                                                      "Clique para editar o código"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.editCode(
                                                        $event,
                                                        investment
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "short-label"
                                                    },
                                                    [_vm._v("Código:")]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(investment.code) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c("v-col", [
                                            _c(
                                              "span",
                                              { staticClass: "short-label" },
                                              [_vm._v("Importação:")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                attrs: {
                                                  title:
                                                    ((investment.message_imp &&
                                                      investment.message_imp.trim()) ||
                                                      "Sem mensagem") +
                                                    " - " +
                                                    _vm.formatDateAbbr(
                                                      investment.date_imp
                                                    )
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      investment.status_imp
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]),
                                          _c("v-col", [
                                            _c(
                                              "span",
                                              { staticClass: "short-label" },
                                              [_vm._v("Data:")]
                                            ),
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatDateAbbr(
                                                  investment.date
                                                )
                                              )
                                            )
                                          ]),
                                          _c("v-col", [
                                            _c(
                                              "span",
                                              { staticClass: "short-label" },
                                              [_vm._v("Vencimento:")]
                                            ),
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatDateAbbr(
                                                  investment.dueDate
                                                )
                                              )
                                            )
                                          ]),
                                          _c("v-col", [
                                            _c(
                                              "span",
                                              { staticClass: "short-label" },
                                              [_vm._v("Marcado?:")]
                                            ),
                                            _vm._v(
                                              _vm._s(
                                                _vm.isSelected(investment)
                                                  ? "☑️"
                                                  : " "
                                              )
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "v-row",
                          { staticClass: "remove-col" },
                          [
                            _c("v-col", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn-cancel",
                                  attrs: {
                                    type: "button",
                                    disabled: _vm.loading,
                                    title:
                                      "Remover o item de importação. Não será mais possível atualizar"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.cancelItem($event)
                                    }
                                  }
                                },
                                [_vm._v(" Remover ")]
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "v-btn",
        {
          staticClass: "close-btn",
          attrs: { icon: "", disabled: _vm.loading },
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [
          _c("img", {
            staticClass: "icon",
            attrs: {
              src: require("@/assets/icons/close.svg"),
              alt: "dashboard"
            }
          })
        ]
      ),
      _vm.displaying
        ? _c("InvestmentDetails", {
            attrs: { source: _vm.target },
            on: {
              close: function($event) {
                _vm.displaying = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }